import { allowedUrls } from "constants";
import { isValidURL } from "utils/StringUtils";
import * as yup from "yup";

const linkUploadValidationSchema = (isMember) =>
  yup.object().shape({
    description: yup
      .string()
      .min(3, "Description is too Short!")
      .max(65000, "Description is too Long!"),
    links: yup
      .array()
      .of(
        yup.object().shape({
          url: yup.string(),
        }),
      )
      .max(30, "You can upload a maximum of 30 links")
      .required("The link is required"),
    link: yup.object().shape({
      url: yup
        .string()
        .min(2, "Text is too Short!")
        .test("is-valid-link", "Link is not valid", (value) => {
          if (!value) return true;
          return isValidURL(value);
        })
        .test("allowed-links", "The Link is not allowed", (value) => {
          if (!value) return true;
          return allowedUrls.some((domain) => {
            if (domain.includes("*")) {
              const regexPattern = domain
                .replace(/\./g, "\\.") // Escape dots
                .replace(/\*/g, ".*") // Convert * to .*
                .replace(/\//g, "\\/"); // Escape forward slashes
              const regex = new RegExp(`^${regexPattern}`);
              return regex.test(value);
            }
            return value?.startsWith(domain);
          });
        }),
    }),
    entity: yup
      .array()
      .test("required", "The Entity is required", (value, context) => {
        if (isMember) {
          return value?.length;
        } else {
          return true;
        }
      }),
  });

export default linkUploadValidationSchema;
